import axios from "axios";

const apiKey = "bdK/XxbJ9ZwWMAF4gwKnIA9rpD8XE6Q4LxF2TjjfHuo=";

const httpService = axios.create({
  baseURL: "https://kindleapi.softidoc.co.za/api/",
  //  baseURL: "http://localhost:5009/api/",
  headers: {
    "Content-Type": "application/json",
    ApiKey: apiKey,
  },
});

export default httpService;
